'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddToList = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _baseTabs = require('@bibliocommons/base-tabs');

var _addCatalogItem = require('../../add-catalog-item');

var _addCatalogItem2 = _interopRequireDefault(_addCatalogItem);

var _addWebItem = require('../../add-web-item');

var _addWebItem2 = _interopRequireDefault(_addWebItem);

var _itemCount = require('../../item-count');

var _itemCount2 = _interopRequireDefault(_itemCount);

require('../styles/AddToList.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddToList = exports.AddToList = function (_BcReactComponent) {
  _inherits(AddToList, _BcReactComponent);

  function AddToList(props) {
    _classCallCheck(this, AddToList);

    var _this = _possibleConstructorReturn(this, (AddToList.__proto__ || Object.getPrototypeOf(AddToList)).call(this, props));

    _this.bindAll('renderAddWebItemTab', 'focusOnTitle');
    return _this;
  }

  _createClass(AddToList, [{
    key: 'focusOnTitle',
    value: function focusOnTitle() {
      if (this._addToListTitle) {
        this._addToListTitle.focus();
      }
    }
  }, {
    key: 'renderAddWebItemTab',
    value: function renderAddWebItemTab() {
      var allowFreeText = this.props.allowFreeText;


      if (!allowFreeText) {
        return _react2.default.createElement('noop', null);
      }

      return _react2.default.createElement(
        _baseTabs.TabContent,
        {
          eventKey: '1',
          tabHref: 'web-item-tab',
          label: AddToList.renderWebItemLabel(),
          testId: 'add-web-item-tab' },
        _react2.default.createElement(_addWebItem2.default, {
          handleAddWebItem: this.props.handleAddWebItem,
          allowFreeText: this.props.allowFreeText,
          listItems: this.props.listItems,
          webItem: this.props.webItem,
          handleWebURLSelected: this.props.handleWebURLSelected,
          handleWebItemPropertyChange: this.props.handleWebItemPropertyChange })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'cp-add-to-list' },
        _react2.default.createElement(
          'div',
          { className: 'title-and-count' },
          _react2.default.createElement(
            'h2',
            { tabIndex: '-1', ref: function ref(element) {
                _this2._addToListTitle = element;
              } },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_title_add_items' })
          ),
          _react2.default.createElement(_itemCount2.default, { count: this.props.listItems.size })
        ),
        _react2.default.createElement(
          'div',
          { className: 'add-item-form' },
          _react2.default.createElement(
            _baseTabs.Tabs,
            { defaultActiveKey: '0' },
            _react2.default.createElement(
              _baseTabs.TabContent,
              {
                eventKey: '0',
                tabHref: 'catalog-item-tab',
                label: AddToList.renderCatalogItemLabel(),
                testId: 'add-catalog-item-tab' },
              _react2.default.createElement(_addCatalogItem2.default, {
                handleSearch: this.props.handleSearch,
                handleAddBib: this.props.handleAddBib,
                listItems: this.props.listItems,
                searchResults: this.props.searchResults,
                searchParams: this.props.searchParams,
                keepSearchResultsOpen: this.props.keepSearchResultsOpen,
                handleSearchParameterChange: this.props.handleSearchParameterChange,
                getNextPageSearchResults: this.props.getNextPageSearchResults,
                handleClearSearch: this.props.handleClearSearch,
                handleCloseAddToList: this.props.handleCloseAddToList,
                availabilityDetailActions: this.props.availabilityDetailActions })
            ),
            this.renderAddWebItemTab()
          )
        )
      );
    }
  }], [{
    key: 'renderCatalogItemLabel',
    value: function renderCatalogItemLabel() {
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _reactIntl.FormattedMessage,
          { id: 'user_list_catalog_item' },
          function (message) {
            return _react2.default.createElement(
              'span',
              { 'aria-hidden': true },
              message
            );
          }
        ),
        _react2.default.createElement(
          _reactIntl.FormattedMessage,
          { id: 'ada_label_add_catalog_item' },
          function (message) {
            return _react2.default.createElement(
              _baseScreenReaderMessage2.default,
              null,
              message
            );
          }
        )
      );
    }
  }, {
    key: 'renderWebItemLabel',
    value: function renderWebItemLabel() {
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _reactIntl.FormattedMessage,
          { id: 'user_list_web_item' },
          function (message) {
            return _react2.default.createElement(
              'span',
              { 'aria-hidden': true },
              message
            );
          }
        ),
        _react2.default.createElement(
          _reactIntl.FormattedMessage,
          { id: 'ada_label_add_web_item' },
          function (message) {
            return _react2.default.createElement(
              _baseScreenReaderMessage2.default,
              null,
              message
            );
          }
        )
      );
    }
  }]);

  return AddToList;
}(_baseBcReactComponent2.default);

AddToList.propTypes = {
  listID: _react.PropTypes.number,
  listItems: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  allowFreeText: _react.PropTypes.bool.isRequired,
  searchResults: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape),
  searchParams: _reactImmutableProptypes2.default.map.isRequired,
  keepSearchResultsOpen: _react2.default.PropTypes.bool,
  handleSearch: _react.PropTypes.func.isRequired,
  handleAddWebItem: _react.PropTypes.func.isRequired,
  getNextPageSearchResults: _react.PropTypes.func.isRequired,
  pageSize: _react.PropTypes.number,
  handleSearchParameterChange: _react.PropTypes.func.isRequired,
  handleClearSearch: _react.PropTypes.func.isRequired,
  handleWebItemPropertyChange: _react.PropTypes.func.isRequired,
  handleCloseAddToList: _react.PropTypes.func.isRequired,
  handleWebURLSelected: _react.PropTypes.func.isRequired,
  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
  intl: _reactIntl.intlShape
};

AddToList.defaultProps = {
  pageSize: 5
};

exports.default = (0, _reactIntl.injectIntl)(AddToList);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/add-to-list/components/AddToList.component.js
// module id = 1273
// module chunks = 0